import {
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';

import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideLogOut } from '@ng-icons/lucide';

import { ZardButtonComponent } from '@/shared/components/button';
import { AuthService } from '@core/auth/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [NgIcon, ZardButtonComponent],
  viewProviders: [provideIcons({ lucideLogOut })],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <header class="flex h-16 items-center justify-between border-b bg-card px-4 lg:px-6">
      <span class="text-lg font-semibold">My enshift Admin</span>

      <div class="flex items-center gap-3">
        @if (auth.currentUser(); as user) {
          <span class="hidden text-sm text-muted-foreground sm:block">{{ user.email }}</span>
        }
        <button
          z-button
          zType="ghost"
          zSize="sm"
          aria-label="Sign out"
          (click)="onSignOut()"
          class="min-h-[44px]"
        >
          <ng-icon name="lucideLogOut" class="size-4" />
          <span class="ml-1 hidden sm:inline">Sign out</span>
        </button>
      </div>
    </header>
  `,
})
export class AppHeaderComponent {
  protected readonly auth = inject(AuthService);

  protected onSignOut(): void {
    this.auth.logout();
  }
}
